export default __webpack_public_path__ + "style-osm-night-500-87d4d164f249bee039706a8ad0f526f7.png";